// Laos eVisa (https://laoevisa.gov.la). Option values are the government form's exact option
// texts so the engine (gov-engine LAeVisa) selects them verbatim.

const LA_PURPOSES = [
	{ label: "Travel (tourism)", value: "Travel" },
	{ label: "Visit (friends or relatives)", value: "Visit" },
	{ label: "Other", value: "Other" }
]

export const LA_FIELDS = {}

export const LA_APPLICATION_FIELDS = {
	purpose_of_trip: {
		type: "select",
		props: {
			label: "Purpose of Trip",
			options: LA_PURPOSES
		}
	},
	vehicle: {
		type: "input",
		props: {
			label: "Flight Number, Train or Vehicle",
			maxLength: 40
		}
	},
	address_during_visit: {
		type: "input",
		props: {
			label: "Address During Visit (hotel, village, province)",
			maxLength: 240
		}
	},
	next_destination: {
		type: "input",
		props: {
			label: "Next Destination",
			maxLength: 240,
			pattern: "[a-zA-Z0-9 ,']*"
		},
		validation: {
			messages: {
				pattern: "Please use only letters, numbers, spaces, commas and apostrophes."
			}
		}
	}
}
